/**
 * Converts an `ArrayBuffer` to a string.
 */

const arrayBufferToString = (input: ArrayBuffer|Uint8Array): string =>
    String.fromCharCode.apply(null, new Uint8Array(input));

export default arrayBufferToString;